import { cn } from '@repo/lib/cn';
import { ErrorMessage } from '@repo/types/messages/error';
import { CircleSlash } from 'lucide-react';

import { EmptyState, EmptyStateCircles, EmptyStateContent, EmptyStateDescription, EmptyStateTitle } from '@/components/ui/empty-state';
import { FeaturedIcon } from '@/components/ui/featured-icon';

interface ErrorStateProps {
  errorMessage?: ErrorMessage;
  className?: string;
}

export default function ErrorState(errorStateProps: ErrorStateProps) {
  const { errorMessage, className } = errorStateProps;
  return (
    <div className={cn('flex h-full w-full items-center justify-center p-4', className)}>
      <EmptyState>
        <EmptyStateCircles className={'z-0'} />
        <FeaturedIcon size={'lg'} className={'z-10'}>
          <CircleSlash />
        </FeaturedIcon>
        <EmptyStateContent>
          <EmptyStateTitle>{errorMessage?.title}</EmptyStateTitle>
          <EmptyStateDescription>{errorMessage?.detail}</EmptyStateDescription>
        </EmptyStateContent>
      </EmptyState>
    </div>
  );
}
